import FilterOption from './filter-option';

class FilterUserOption extends FilterOption {
  constructor(data, label) {
    super(data, label);

    if (!data.directProjects) {
      this.withoutDirectProjects = true;
    }
  }
}

export default FilterUserOption;
